import ProceedCheckout from '@components/ProceedCheckout';
import StickyCTA from '@components/StickyCTA';
import { useTranslations } from 'next-intl';
import { useCartMaxWeight } from '@hooks/useCartMaxWeight';

interface ICheckoutCTAProps {
  totalPrice: number;
  totalEconomy: number;
  weight: number;
  children?: React.ReactNode;
}

const CheckoutCTA: React.FC<ICheckoutCTAProps> = ({
  weight,
  totalPrice,
  totalEconomy,
  children,
}) => {
  const maxWeight = useCartMaxWeight();
  const tCart = useTranslations('Cart');

  return (
    <StickyCTA
      weight={weight}
      totalPrice={totalPrice}
      totalEconomy={totalEconomy}
      withWeightLimitMessage
    >
      {children ? (
        children
      ) : (
        <ProceedCheckout
          disabledButton={totalPrice === 0 || weight >= maxWeight}
          paymentButtonLabel={tCart('continueToDelivery')}
          dataTestId="ProceedCheckout-Button-go-to-checkout-delivery-mobile"
        />
      )}
    </StickyCTA>
  );
};

export default CheckoutCTA;
